  /**
   * @memberof rmOBA
   * @ngdoc directive
   * @name rmCookieBanner
   * @param  {service} $alert alert directive from Angular Strap: http://mgcrea.github.io/angular-strap/#/alerts
   * @param  {service} $cookies     Angular Cookie Provider: Provides read/write access to browser's cookies.
   * @description
   *   Standard H&C Angular Cookie banner directive.
   *   Show a cookie banner, if user clicks button then close banner and store cookie. 
   *   Do not show cookie banner if cookie exists.
   * @example
   *   Usage:
   *   <rm-cookie-banner></rm-cookie-banner>
   */
rmOBA.directive('rmCookieBanner', [
    '$alert',
    '$cookies', function(
        $alert,
        $cookies
    ) {
    return {
        restrict: 'E',
        templateUrl: 'directives/rmCookieBanner/rmCookieBanner.html',
        scope: true,
        link: function (scope) {

            scope.cookieBannerCookie = $cookies.get('hideCookieBanner') || 0;
            scope.content = "OBA uses cookies to ensure that we give you the best experience on our website. If you continue without changing your settings, we will assume that you are happy to receive all cookies from this site.";
            scope.linkText = "Learn more about our cookie policy";
            scope.linkHref = "http://www.royalmail.com/cookies-policy";


            /**
            * @memberof rmCookieBanner
            * @function hideBanner
            * @desc hides the banner
            * @param {object} obj element object from click event
            * @param {object} $event event object from click event
            */
           
            // Hide the intro notice and set a cookie so it does not show for the next 24 hours
            scope.hideBanner = function (obj, $event) {

                $cookies.put('hideCookieBanner', '1');
                $event.target.parentNode.parentNode.parentNode.removeChild($event.target.parentNode.parentNode);
            }
        }
    }
}]);